import * as React from "react";
import Skeleton from "@mui/material/Skeleton";

export default function FeedbackAndWaitlistSkeleton() {
  return (
    <div className="feedback-waitlist-card">
      <div className="feedback-card">
        <Skeleton variant="text" width="40%" sx={{ fontSize: "1rem" }} />

        <div className="feedback-item">
          <Skeleton variant="text" width="30%" sx={{ fontSize: "1rem" }} />
          <Skeleton variant="text" width="5%" sx={{ fontSize: "1rem" }} />
        </div>
        <Skeleton variant="text" width="100%" sx={{ fontSize: "1rem" }} />
        <div className="feedback-item">
          <Skeleton variant="text" width="30%" sx={{ fontSize: "1rem" }} />
          <Skeleton variant="text" width="5%" sx={{ fontSize: "1rem" }} />
        </div>
        <Skeleton variant="text" width="100%" sx={{ fontSize: "1rem" }} />
        <div className="feedback-item">
          <Skeleton variant="text" width="30%" sx={{ fontSize: "1rem" }} />
          <Skeleton variant="text" width="5%" sx={{ fontSize: "1rem" }} />
        </div>
        <Skeleton variant="text" width="100%" sx={{ fontSize: "1rem" }} />
        <Skeleton variant="text" width="50%" height={10} sx={{ fontSize: "1rem" }} />
      </div>

      <div className="waitlist-container">
        <div className="table-wrapper" style={{ display: "flex" }}>
          <table className="waitlist-table">
            <Skeleton
              width={150}
              height={50}
              variant="text"
              sx={{ fontSize: "1rem" }}
            />
            <Skeleton
              width={150}
              height={50}
              variant="text"
              sx={{ fontSize: "1rem" }}
            />
            <Skeleton
              width={150}
              height={50}
              variant="text"
              sx={{ fontSize: "1rem" }}
            />
            <Skeleton
              width={150}
              height={50}
              variant="text"
              sx={{ fontSize: "1rem" }}
            />
            <Skeleton
              width={150}
              height={50}
              variant="text"
              sx={{ fontSize: "1rem" }}
            />
            <Skeleton
              width={150}
              height={50}
              variant="text"
              sx={{ fontSize: "1rem" }}
            />
            <Skeleton
              width={150}
              height={50}
              variant="text"
              sx={{ fontSize: "1rem" }}
            />
          </table>
          <table className="waitlist-table">
            <Skeleton
              width={150}
              height={50}
              variant="text"
              sx={{ fontSize: "1rem" }}
            />
            <Skeleton
              width={150}
              height={50}
              variant="text"
              sx={{ fontSize: "1rem" }}
            />
            <Skeleton
              width={150}
              height={50}
              variant="text"
              sx={{ fontSize: "1rem" }}
            />
            <Skeleton
              width={150}
              height={50}
              variant="text"
              sx={{ fontSize: "1rem" }}
            />
            <Skeleton
              width={150}
              height={50}
              variant="text"
              sx={{ fontSize: "1rem" }}
            />
            <Skeleton
              width={150}
              height={50}
              variant="text"
              sx={{ fontSize: "1rem" }}
            />
            <Skeleton
              width={150}
              height={50}
              variant="text"
              sx={{ fontSize: "1rem" }}
            />
          </table>
          <table className="waitlist-table">
            <Skeleton
              width={150}
              height={50}
              variant="text"
              sx={{ fontSize: "1rem" }}
            />
            <Skeleton
              width={150}
              height={50}
              variant="text"
              sx={{ fontSize: "1rem" }}
            />
            <Skeleton
              width={150}
              height={50}
              variant="text"
              sx={{ fontSize: "1rem" }}
            />
            <Skeleton
              width={150}
              height={50}
              variant="text"
              sx={{ fontSize: "1rem" }}
            />
            <Skeleton
              width={150}
              height={50}
              variant="text"
              sx={{ fontSize: "1rem" }}
            />
            <Skeleton
              width={150}
              height={50}
              variant="text"
              sx={{ fontSize: "1rem" }}
            />
            <Skeleton
              width={150}
              height={50}
              variant="text"
              sx={{ fontSize: "1rem" }}
            />
          </table>
        </div>
      </div>
    </div>
  );
}
